"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function GDDHeader() {
    return ((0, jsx_runtime_1.jsx)("div", { style: { textAlign: "center", marginTop: 50, fontSize: "1.5rem" }, children: (0, jsx_runtime_1.jsx)("h1", { children: "GDD CREATOR" }) }));
}
exports.default = GDDHeader;
